<template>
  <div>
    <p class="text-body whitespace-pre-wrap break-words [overflow-wrap:anywhere]">{{ body }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MessageBubbleBody',
  props: {
    body: {
      type: String,
      default: '',
    },
  },
};
</script>
